// extracted by mini-css-extract-plugin
export default {"toastBack":"Toast_toastBack__GXOGH","toastCard":"Toast_toastCard__9bf16","toastText":"Toast_toastText__i44k8"};